import { IBaseDataParser } from "../../core/src/server/parsers/IBaseDataParser";
import { IVendorData } from "../model/VendorModel";
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";

const TEST = false;

export default class VendorDataParser implements IBaseDataParser<IVendorData> {
    public check(data: any): boolean {
        if (TEST) {
            data = this.getTestData();
        }

        return (data && data.stats && data.stats.freespins) || (data && data.freespins);
    }

    public parse(data: any): IVendorData {
        if (TEST) {
            data = this.getTestData();
        }

        let result;

        if(data.stats) {
            result = {
                freeGames: data.stats.freespins,
            };
        } else {
            result = {
                freeGames: data.freespins,
            }
        }


        ConsoleUtil.log("[VendorDataParser] data:", result);

        return result;
    }

    private getTestData() {
        return {
            stats: {
                freespins: {
                    spins: 10,
                    spinsPlayed: 0,
                    type: "money",
                    win: 0,
                    spinsended: false,
                    ba: 5,
                    expires: new Date().getTime() + 3000,
                    autoplay: true,
                    // betSizeOptions: [
                    //     {
                    //         spins: 10,
                    //         ba: 5,
                    //     },
                    //     {
                    //         spins: 5,
                    //         ba: 10,
                    //     },
                    //     {
                    //         spins: 2,
                    //         ba: 25,
                    //     },
                    //     {
                    //         spins: 1,
                    //         ba: 50,
                    //     },
                    // ],
                },
            },
        };
    }
}
